var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.896 8.851 17.36 2.5h-1.294L11.32 8.015 7.531 2.5h-4.37l5.73 8.34-5.73 6.66h1.295l5.01-5.824L13.47 17.5h4.37zm-1.773 2.062-.581-.83-4.618-6.608h1.988l3.728 5.333.581.83 4.846 6.931h-1.989z"
  })));
};
export default SvgTwitterIcon;